import { render, staticRenderFns } from "./bulk-edit-modal.vue?vue&type=template&id=5a156319&scoped=true&"
import script from "./bulk-edit-modal.vue?vue&type=script&lang=ts&"
export * from "./bulk-edit-modal.vue?vue&type=script&lang=ts&"
import style0 from "./bulk-edit-modal.vue?vue&type=style&index=0&id=5a156319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a156319",
  null
  
)

export default component.exports